export enum PotentialWorkArea {
  NTWorkArea = 'NT.WA-KNITTING-1',
  SIMTEXWorkArea = 'SIMTEX.WA-KNITTING-2',
  GUAKWorkArea = 'GUAK.WA-KNITTING-3',
}
